<template>
  <component
    :is="buttonType"
    class="app-button"
    :class="[buttonSize, buttonColor]"
    :href="link"
  >
    <div class="app-button__content">
      <slot />
    </div>
  </component>
</template>

<script>
export default {
  props: {
    link: String,
    size: String,
    color: String,
  },
  computed: {
    buttonSize() {
      return `app-button--${this.$props.size}`;
    },
    buttonColor() {
      return this.$props.color ? `app-button--${this.$props.color}` : "";
    },
    buttonType() {
      const type = this.$props.link ? "a" : "button";
      return type;
    },
  },
};
</script>

<style lang="scss">
.app-button {
  border: none;
  cursor: pointer;
  display: block;
  transition: all 300ms ease-in-out;
  // @include button-text;
  &--big,
  &--large {
    font-size: 16px;
    @include tablet {
      font-size: 20px;
    }
    min-height: 100px;
    .app-button__content {
      min-height: 100px;
    }
  }
  &--small {
    font-size: 18px;
    min-height: 40px;
    padding: 0 0.75rem;
    .app-button__content {
      min-height: 40px;
    }
  }
  &:disabled {
    $bg: transparent !important;
    background-color: $bg;
    border: solid get-color("grey") 1px;
    color: black !important;
    cursor: not-allowed;
    font-style: italic;
    font-weight: 100;
    &:hover,
    &:focus {
      background-color: $bg;
      color: black !important;
    }
  }
  &--green {
    background-color: get-color("green");
    color: white;
    &:hover,
    &:focus {
      background-color: get-color("brown");
    }
  }
  &--brown {
    background-color: get-color("brown");
    color: white;
    &:hover,
    &:focus {
      background-color: get-color("teal");
    }
  }
  &--teal {
    background-color: get-color("teal");
    color: white;
    &:hover,
    &:focus {
      background-color: get-color("brown");
    }
  }
  &--grey {
    background-color: get-color("grey");
    color: white;
    &:hover,
    &:focus {
      background-color: get-color("teal");
    }
  }
  &--blue {
    background-color: get-color("blue");
    color: white;
    &:hover,
    &:focus {
      background-color: get-color("green");
    }
  }
  &--red {
    background-color: get-color("red");
    color: white;
    &:hover,
    &:focus {
      background-color: white;
      color: black;
    }
  }
  &--orange {
    background-color: get-color("orange");
    color: white;
    &:hover,
    &:focus {
      background-color: white;
      color: black;
    }
  }
  &--orange {
    background-color: get-color("orange");
    color: white;
    &:hover,
    &:focus {
      background-color: white;
      color: black;
    }
  }
  &__content {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 100%;
    word-break: break-word;
    height: 100%;
  }
  &__link {
    color: currentColor;
  }
}
</style>
